import React, { useState, useEffect, useContext } from "react"
import Loader from "../ui/loader"
import { Button } from "../ui/button"
import { CoachPublicProfileContext } from "../../pages/manage-business/profile/context/coachPublicProfileContext"
import { getLightTextColor } from "../../utils/getLightTextColor"
import { ProfileRequests } from "../../api/app.service"
import { useToast } from "../../hooks/useToast"
import { useNavigate } from "react-router-dom"

interface Props {
  selectedTestimonialId: number | undefined
  setActiveTab: any
  uploadedImg?: string
}

const PublicOverViewTestimonials: React.FC<Props> = ({
  selectedTestimonialId,
  setActiveTab,
  uploadedImg,
}: Props) => {
  const { toast } = useToast()
  const { coachPublicProfileData } = useContext(CoachPublicProfileContext)
  const [isLoading, setIsLoading] = useState(false)
  const [testimonial, setTestimonial] = useState<any>()
  const navigate = useNavigate()
  const textColor = getLightTextColor(
    coachPublicProfileData?.profile_information?.profileColor
  )

  const getCoachTestimonials = async () => {
    setIsLoading(true)
    ProfileRequests.getTestimonials({
      coach_public_profile_id: coachPublicProfileData?.coach_public_profile_id,
    })
      .then((data: any) => {
        const allTestimonials = data.testimonials
        let firstTestimonial = allTestimonials[0]
        const indexOfSelectedTestimonial = allTestimonials.findIndex(
          (testimonial: any) => testimonial.id === selectedTestimonialId
        )
        if (indexOfSelectedTestimonial !== -1) {
          firstTestimonial = allTestimonials[indexOfSelectedTestimonial]
        }
        setTestimonial(firstTestimonial)
      })
      .catch((ex: any) => {
        console.error(ex)
        toast.error("something went wrong")
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleSeeAllTestimonials = () => {
    navigate(
      `/providers/${coachPublicProfileData?.endpoint_slug}/testimonials`
    )
  }

  useEffect(() => {
    getCoachTestimonials()
  }, [coachPublicProfileData])

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="h-full w-full">
          {testimonial ? (
            <div
              className="flex h-full w-full flex-col justify-between rounded-[20px] p-4 bg-cover bg-center bg-no-repeat"
              style={{
                backgroundColor: `${textColor}`,
                backgroundImage: uploadedImg
                  ? `url(${uploadedImg})`
                  : undefined,
              }}
            >
              <Button
                onClick={handleSeeAllTestimonials}
                variant={"ghost"}
                size={"sm"}
                className="absolute right-4 top-[10px] text-sm"
              >
                See All
              </Button>
              <h1 className="font-bold">Testimonials</h1>
              <p className="line-clamp-[8] max-w-[250px] self-center italic">
                {testimonial?.testimonial}
              </p>
              <p className="pl-4 text-xs font-medium">
                {testimonial?.client_name
                  ? testimonial.client_name
                  : "Anonymous Member"}
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  )
}

export default PublicOverViewTestimonials
